export default __webpack_public_path__ + "static/Noroutine_Talent_Scouting_Terms_Candidate_DE_03_2020-9b8c3040f64001942e916c7521dc9559.pdf";